import { yup } from '@framework/validation';
import { fromPairs, merge } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator/form-builder/flags/FormBuilderMetaFlags';
import { type ICreateWidgetFormSchemaInput } from '../../../IWidgetType';
import {
  ButtonActionType,
  type IButtonActionExecAsyncService,
} from './actions/IButtonAction';
import { getActionDataObjectName } from './getActionDataObjectName';
import { type IButtonWidget } from './IButtonWidget';

export function createButtonWidgetSchema(
  input: ICreateWidgetFormSchemaInput<IButtonWidget>,
) {
  const { widget } = input;

  const serviceActions =
    widget.actions
      ?.map((action, index) => ({ action, index }))
      ?.filter(
        (a): a is { action: IButtonActionExecAsyncService; index: number } =>
          a.action.type === ButtonActionType.ExecAsyncService,
      ) ?? [];

  if (serviceActions.length === 0) return {};

  const serviceActionSchema = serviceActions.map(action => {
    const outputs = action.action.outputs ?? [];
    return {
      [getActionDataObjectName(widget, action.index)]: yup
        .object(fromPairs(outputs.map(output => [output.name, yup.string()])))
        .formBuilderFlags(
          FormBuilderMetaFlags.SkipDefaultValue,
          FormBuilderMetaFlags.SkipValidationRules,
        )
        .notRequired(),
    };
  });

  return merge({}, ...serviceActionSchema);
}
